export default {
  getCart(state) {
    return state;
  }
};
